'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './gallery-list.routes';

export class GalleryListComponent {
  constructor(GalleryService, $state, Auth, Config) {
    'ngInject';

    this.isAdmin = Auth.isAdminSync;
    this.$state = $state;
    this.GalleryService = GalleryService;
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, this.type + " Galleries");
    this.galleryUserContributionAllowed = Config.getModuleConfig(Config.Modules.Gallery).getTypesUserContribution();
  }

  $onInit() {
    let METHOD = this.public ? "getPublicByType": "getByType";

    this.GalleryService[METHOD]({type: this.type}, data => {
      this.galleries = data;
    }, err => {
      console.log("Could not retrived galleries from server");
    })
  }

  getPath(id) {
    if (this.public)
      return "/public/gallery/" + id;
    else
      return "/gallery/" + id;
  }

  getUserShort(user) {
    return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
  }

  userContributionAllowed() {
    return this.galleryUserContributionAllowed
      && this.galleryUserContributionAllowed.indexOf(this.type) !== -1;
  }
}

export default angular.module('conduuApp.galleryList', [uiRouter])
  .config(routes)
  .component('galleryList', {
    template: require('./gallery-list.html'),
    controller: GalleryListComponent,
    controllerAs: 'ctrl',
    bindings: {
      type: '@',
      public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/gallery/list/gallery-list.component.js